import { defaultFilter } from '../constants';
import { EventsFilter } from '../interfaces';
import { useEventsFilter } from '../queries/eventsFilter';

export const useFilter = (): EventsFilter => {
  const { data: filter } = useEventsFilter();

  return filter ?? defaultFilter();
};
